import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import { FadeIn, Stagger, StaggerItem } from "../components/Motion";
import { STATS, VALUES } from "../data/site";

const officeImg =
  "https://images.unsplash.com/photo-1772001936267-b6058748eff4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBnbGFzcyUyMGNvcnBvcmF0ZSUyMG9mZmljZSUyMGludGVyaW9yfGVufDB8fHx8MTc3NjgzODYyN3ww&ixlib=rb-4.1.0&q=85";
const teamImg =
  "https://images.unsplash.com/photo-1758518731457-5ef826b75b3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBidXNpbmVzcyUyMHRlYW0lMjBjb2xsYWJvcmF0aW9ufGVufDB8fHx8MTc3NjgzODYyN3ww&ixlib=rb-4.1.0&q=85";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="pt-36 pb-20 md:pt-44 md:pb-28 text-center">
        <div className="max-w-6xl mx-auto px-6 md:px-12">
          <FadeIn>
            <div className="flex items-center justify-center gap-6 mb-8">
              <div className="h-[1px] w-16 bg-[#0b2e5e]/20" />
              <span className="issue-stripe">§ 02 · About the Studio</span>
              <div className="h-[1px] w-16 bg-[#0b2e5e]/20" />
            </div>
            <h1 className="font-display text-5xl sm:text-7xl lg:text-[108px] tracking-[-0.03em] font-semibold leading-[0.9] text-[#0b2e5e]">
              A studio built for
              <br />
              <span className="font-serif-italic text-[#e11d48]">ambitious</span> brands.
            </h1>
          </FadeIn>
          <FadeIn delay={0.2}>
            <p className="mt-10 max-w-2xl mx-auto text-lg md:text-xl text-[#0b2e5e]/75 leading-relaxed">
              Madly Digital is a full-scale digital marketing agency based in Kolkata, India. We partner with growing businesses on the work that will define their next chapter — blending creativity, strategy, and technology.
            </p>
          </FadeIn>
          <FadeIn delay={0.35}>
            <div className="mt-10 flex flex-wrap items-center justify-center gap-3">
              <div className="sticker"><span className="dot" style={{ background: "#14B8A6" }} /> Founded 2019</div>
              <div className="sticker"><span className="dot" style={{ background: "#F97316" }} /> 50+ Clients served</div>
              <div className="sticker"><span className="dot" style={{ background: "#8B5CF6" }} /> Kolkata · Mumbai · Delhi</div>
              <div className="sticker"><span className="dot" style={{ background: "#E11D48" }} /> Performance-driven & Motivated</div>
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-6">
          <FadeIn>
            <div className="glass rounded-3xl overflow-hidden relative min-h-[420px]">
              <img src={officeImg} alt="office" className="absolute inset-0 h-full w-full object-cover opacity-50" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#FAF6EF] via-[#FAF6EF]/20 to-[#FAF6EF]/20" />
              <div className="relative z-10 h-full flex items-end p-8">
                <div>
                  <div className="font-mono-mini text-[#00F0F0]">Origin</div>
                  <h3 className="font-display text-3xl md:text-4xl mt-2 max-w-md">
                    Founded in 2019 as a bold two-person idea in the heart of Kolkata.
                  </h3>
                </div>
              </div>
            </div>
          </FadeIn>
          <FadeIn delay={0.15}>
            <div className="glass rounded-3xl overflow-hidden relative min-h-[420px]">
              <img src={teamImg} alt="team" className="absolute inset-0 h-full w-full object-cover opacity-50" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#FAF6EF] via-[#FAF6EF]/20 to-[#FAF6EF]/20" />
              <div className="relative z-10 h-full flex items-end p-8">
                <div>
                  <div className="font-mono-mini text-[#FF3366]">Today</div>
                  <h3 className="font-display text-3xl md:text-4xl mt-2 max-w-md">
                    A team of specialists across design, marketing, and technology.
                  </h3>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <FadeIn>
            <span className="tag">By the numbers</span>
            <h2 className="font-display text-4xl md:text-6xl mt-4 max-w-3xl">
              A decade of work. One obsession: craft.
            </h2>
          </FadeIn>

          <Stagger className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-6">
            {STATS.map((s) => (
              <StaggerItem key={s.label}>
                <div className="glass rounded-3xl p-8">
                  <div className="font-display text-5xl grad-text">{s.value}</div>
                  <div className="mt-3 text-[#0b2e5e]/65">{s.label}</div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <FadeIn>
            <span className="tag">Principles</span>
            <h2 className="font-display text-4xl md:text-6xl mt-4 max-w-3xl">
              What we believe.
            </h2>
          </FadeIn>

          <Stagger className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
            {VALUES.map((v, i) => (
              <StaggerItem key={v.title}>
                <div className="border-t border-[#0b2e5e]/12 pt-8">
                  <div className="font-mono-mini text-[#0b2e5e]/50">{String(i + 1).padStart(2, "0")}</div>
                  <h3 className="font-display text-3xl md:text-4xl mt-3">{v.title}</h3>
                  <p className="text-[#0b2e5e]/65 mt-4 text-base md:text-lg leading-relaxed max-w-lg">{v.body}</p>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </div>
      </section>

      <section className="py-24">
        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
          <FadeIn>
            <h2 className="font-display text-4xl md:text-6xl">
              Want to work together?
            </h2>
            <p className="mt-6 text-[#0b2e5e]/65 max-w-2xl mx-auto">
              We take on a small number of partnerships each quarter. Tell us about the problem you're trying to solve.
            </p>
            <Link to="/contact" className="btn-primary mt-10" data-testid="about-cta-contact">
              Start a conversation <ArrowUpRight weight="bold" size={16} />
            </Link>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
